<template>
  <popup
    :button-style="catColor"
    :heading="'Add ' + (localCat ? localCat : 'Organisation')"
    size="medium"
    button-icon="fa fa-plus"
    :centerButton="true"
    :showText="showText"
    :buttonText="localCat ? localCat : 'Add'"
    :disableButton="disabled"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <div style="clear: both; text-align: left;" v-if="localCat">
      <el-form ref="orgForm" v-model="form">

        <el-row :gutter="16">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item :label="form.category + ' Name'">
              <el-input v-model="form.name"
                placeholder="Name">
                <template #prepend><i class="fa fa-user"></i></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="Short Name">
            <el-tooltip content="e.g. Axis International Ltd can be shortened to AXIS" placement="right" :hide-after="4800">
              <el-input v-model="form.shortName"
                placeholder="Short Name">
              </el-input>
            </el-tooltip>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="Registration No">
          <el-input v-model="form.registrationNo"
            placeholder="Registration No.">
            <template #prepend><i class="fa fa-id-badge"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="Web Site">
          <el-input v-model="form.website"
            placeholder="Web Site">
            <template #prepend><i class="fa fa-globe"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

    </el-row>


      <el-form-item label="Address">
        <el-input type="textarea" :rows="3"
          v-model="form.address"
          placeholder="Address">
          <template #prepend><i class="fa fa-home"></i></template>
        </el-input>
      </el-form-item>

      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="Post Code">
            <el-input  v-model="form.postCode"
              placeholder="Post Code" >
              <template #prepend><i class="fa fa-barcode"></i></template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="Phone">
            <el-input type="phone" v-model="form.phone"
            placeholder="Phone">
              <template #prepend><i class="fa fa-phone"></i></template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="E-Mail">
          <el-input  type="email"
          v-model="form.email"
          placeholder="E-Mail" >
            <template #prepend><i class="fa fa-envelope"></i></template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <h3>Bank Details</h3>
    <el-row :gutter="16">
      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="Beneficiary Name #1">
          <el-input placeholder="Beneifciary Name"
          v-model='form.beneficiaryName1' />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="Bank Name #1">
          <el-input placeholder="Bank Name"
          v-model='form.bankName1' />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label='Bank Account #1'>
          <el-input placeholder="Account No."
          v-model='form.bankAccount1' />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="12" :md="8">
        <el-form-item label="Beneficiary Name #2">
          <el-input placeholder="Beneifciary Name"
            v-model='form.beneficiaryName2' />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="Bank Name #2">
            <el-input placeholder="Bank Name"
            v-model='form.bankName2' />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label='Bank Account #2'>
            <el-input placeholder="Account No."
            v-model='form.bankAccount2' />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="Beneficiary Name #3">
            <el-input placeholder="Beneifciary Name"
              v-model='form.beneficiaryName3' />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="Bank Name #3">
              <el-input placeholder="Bank Name"
                v-model='form.bankName3' />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label='Bank Account #3'>
                <el-input placeholder="Account No."
                  v-model='form.bankAccount3' />
                </el-form-item>
              </el-col>
            </el-row>

        </el-row>
      </el-form>
    </div>

    <div v-else>
      <el-alert
      type="warning"
      title="Category Must Be Provided"
      description="A category must be provided to create and organisation."
      show-icon />
    </div>

  </popup>
</template>



<script>



import SiteMixins from '@/mixins/SiteMixins'

export default {
  mixins: [SiteMixins],

  props: {
    value: {
      default: null
    },

    category: {
      type: String,
      required: true
    },

    showText: {
      type: Boolean,
      default: true
    },

    tableRef: {
      type: String,
      default: 'orgtable'
    },

    isAdd: {
      type: Boolean,
      default: true
    },

    isDisabled: {
      type: Boolean,
      default: null
    }

  },

  watch: {
    category: function (value) {
      this.localCat = value
      this.form.category = this.localCat
    }
  },

  computed: {
    catColor () {
      if (this.localCat) {
          switch (this.localCat) {
            case 'Contractor': return 'warning'
            case 'Telco': return 'primary'
            case 'Backhaul': return 'info'
            case 'Tower Supplier': return 'danger'
            default: return 'success'
          }
      } else {
        return 'success'
      }
    }
  },

  methods: {
    resetData () {
      this.form = {}
      this.form.category = this.localCat
    },

    onSaveDialog () {

      if (!this.value) {
        this.saveForm(this, '/org', null, this.form, 'Organisation', this.successOrg, this.failOrg)
      }

    },

    successOrg (value) {

      this.updateConfig()
      this.$events.emit(this.tableRef + '-refresh-table')

      if (this.isAdd) {
        this.resetData()
      }

    },

    failOrg (value) {
      this.resetData()
    },

    onCloseDialog () {
      this.resetData()
    }

  },

  data () {
    return {
      localCat: this.category,
      form: this.value ? this.value : this.getTableStruct('organisation'),
      disabled: this.isBoolean(this.isDisabled) ? this.isDisabled : !this.isManager('project|maintenance|property|finance|admin')
    }
  }, // data

  created () {

    if (this.form) {
      this.form.category = this.localCat
    }
  }
}

</script>

<style>
.el-select {display: inline-block;}
</style>
